import { faq } from './type'
import faq202206 from './51220061'
import faq202209 from './51220091'

const faqs: { [exmaId: string]: faq[] } = {
  '51220061': faq202206, // 2022年度6月WEB完結型テスト
  '51220091': faq202209, // 2022年度9月とじ込み型テスト
}

export default faqs
